<template>
    <div class="bc-shift">
        <div class="bc-card" :style="{ width }">
            <div v-if="title || eyebrow" class="bc-head">
                <slot name="head-left" />
                <div class="bc-head__text">
                    <div v-if="eyebrow" class="bc-eyebrow">{{ eyebrow }}</div>
                    <div v-if="title" class="bc-title">{{ title }}</div>
                </div>
                <slot name="head-right" />
            </div>
            <slot />
        </div>
    </div>
</template>

<script>
    // The white card every break screen of the live stream sits in (1920x1080, next to the match info on the left)
    export default {
        name: 'BroadcastCard',
        props: {
            title: {
                type: String,
                default: ''
            },
            // small grey line above the title
            eyebrow: {
                type: String,
                default: ''
            },
            width: {
                type: String,
                default: '1150px'
            }
        }
    }
</script>

<style scoped>
/* clears the match info header on the left of the screen */
.bc-shift {
    transform: translateX(300px);
}

@media (max-width: 960px) {
    .bc-shift {
        transform: translateX(3%);
    }
}

.bc-card {
    max-width: calc(100vw - 760px);
    padding: 28px 40px 32px;
    border-top: 6px solid #03e5b7;
    border-radius: 10px;
    background: #232323;
    box-shadow: 0 18px 40px rgba(0, 0, 0, 0.45);
    color: #fff;
    font-family: Roboto, Arial, sans-serif;
    font-weight: 400;
    text-align: left;
}

.bc-head {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 22px;
}

.bc-head__text {
    flex: 1;
    min-width: 0;
}

.bc-eyebrow {
    color: rgba(255, 255, 255, 0.62);
    font-size: 1.05rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.bc-title {
    background-image: linear-gradient(315deg, #03e5b7 0%, #037ade 74%);
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: 'Squada One', 'Roboto Condensed', Arial, sans-serif;
    font-size: 3rem;
    font-weight: 400;
    letter-spacing: 0.03em;
    line-height: 1.1;
}
</style>
